import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './serialNumberInput.css';
import axios from 'axios';
import BASE_URL from '../../config';

const SerialNumberInput = () => {
  const [device_key, setDeviceKey] = useState('');
  const [case_key, setCaseKey] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleDeviceKeyChange = (event) => {
    setDeviceKey(event.target.value);
    if (error) setError('');
  };

  const handleCaseKeyChange = (event) => {
    setCaseKey(event.target.value);
    if (error) setError('');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!device_key.trim()) {
      setError('Please enter a device key.');
      return;
    }

    setIsSubmitting(true);

    try {
      const deviceResponse = await axios.get(`${BASE_URL}/api/register_device_key_check`, {
        params: { device_key: device_key },
      });

      if (!deviceResponse.data.exists) {
        setError("Invalid device key");
        return;
      }

      if (case_key.trim()) {
        const caseResponse = await axios.get(`${BASE_URL}/api/register_case_key_check/`, {
          params: { case_key: case_key },
        });

        if (!caseResponse.data.exists) {
          setError("Invalid case key");
          return;
        }

        navigate(`/signup/${device_key}/${case_key}`);
      } else {
        navigate(`/signup/${device_key}`);
      }
    } catch (error) {
      setError('Failed to validate. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const hasError = error.length > 0;

  return (
    <div className="serial-number-page-wrapper">
      <main className="serial-number-container" role="main">
        <h1 className="serial-heading">Enter Device Key</h1>
        <form onSubmit={handleSubmit} aria-label="Device key validation" noValidate>
          <label htmlFor="device-key-input" className="serial-label">
            Device Key
            <span className="required-indicator" aria-hidden="true"> *</span>
          </label>
          <input
            id="device-key-input"
            type="text"
            value={device_key}
            onChange={handleDeviceKeyChange}
            placeholder="Enter device key"
            className={`serial-input-field ${hasError ? 'serial-input-error' : ''}`}
            aria-required="true"
            aria-invalid={hasError ? 'true' : 'false'}
            aria-describedby={hasError ? 'device-key-error' : undefined}
            autoComplete="off"
          />
          <label htmlFor="case-key-input" className="serial-label">
            Case Key
            <span className="required-indicator" aria-hidden="true"> (optional)</span>
          </label>
          <input
            id="case-key-input"
            type="text"
            value={case_key}
            onChange={handleCaseKeyChange}
            placeholder="Enter case key (optional)"
            className="serial-input-field"
            autoComplete="off"
          />
          <button
            type="submit"
            className="serial-submit-button"
            disabled={isSubmitting}
            aria-busy={isSubmitting}
          >
            {isSubmitting ? 'Validating...' : 'Submit'}
          </button>
        </form>
        {error && (
          <p id="device-key-error" className="serial-error-message" role="alert" aria-live="assertive">
            {error}
          </p>
        )}
      </main>
    </div>
  );
};

export default SerialNumberInput;
